import { render } from "./PDOIOS.vue?vue&type=template&id=5940165c"
import script from "./PDOIOS.vue?vue&type=script&lang=js"
export * from "./PDOIOS.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__